<!--
 * @Author: your name
 * @Date: 2020-04-16 14:06:24
 * @LastEditTime: 2020-04-16 14:17:40
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \h5_hot_mall\src\App.vue
 -->
<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view />
      
    </keep-alive> -->

<div v-if="isShow">
<keep-alive>
    <!-- 需要缓存的视图组件 -->
  <router-view v-if="$route.meta.keepAlive">
  </router-view>
</keep-alive>

<!-- 不需要缓存的视图组件 -->
<router-view v-if="!$route.meta.keepAlive">
</router-view>

</div>



    <!-- v-if="$route.meta.keepAlive" -->
  </div>
</template>


<script>
export default {
  provide() {
    return {
      pageRedown: this.pageRedown,
    }
  },
  data() {
    return {
      isShow: true,
    }
  },
  created() {
    
  },
  methods: {
    pageRedown() {
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
      })
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f6f5f8;
  font-size: 0.56rem;
  height: 100%;
}

.flex {
  display: flex;
}

.flex_a {
  display: flex;
  justify-content: space-around;
}

.flex_b {
  display: flex;
  justify-content: space-between;
}

.t_line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.t_line2,
.dbellipsis {
  display: box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bacwhite {
  background: white;
}

.w100 {
  width: 100%;
}

.van-uploader__input-wrapper,
.van-uploader__wrapper,
.van-uploader {
  width: 100%;
}

b {
  font-weight: normal;
}

em {
  font-style: normal;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 0.58rem;
  font-weight: normal;
}

strong,
b {
  font-weight: normal;
}

em,
i {
  font-style: normal;
}

a {
  text-decoration: none;
  color: #000;
}

.mod {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 988;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
}

dl,
ul {
  margin: 0;
  padding: 0;
}
</style>